import { City, State } from "country-state-city";
import React from "react";
import { SiteLevel } from "../../types/SiteLevel";

interface LocationPickerProps {
  level?: SiteLevel;
  provinces?: string[];
  province: string;
  city: string;
  address: string;
  setProvince: (province: string) => void;
  setCity: (city: string) => void;
  setAddress: (address: string) => void;
  onChange?: (field: string) => void;
}

export const LocationPicker: React.FC<LocationPickerProps> = ({
  level,
  provinces,
  province,
  city,
  address,
  setProvince,
  setCity,
  setAddress,
  onChange,
}) => {
  const countryCode = "NG"; // Restrict to Nigeria
  const states = State.getStatesOfCountry(countryCode).filter((state) =>
    provinces ? provinces.includes(state.isoCode) : true,
  );

  // Fetch cities dynamically when a province is picked
  const cities = province ? City.getCitiesOfState(countryCode, province) : [];

  return (
    <div className="flex flex-col gap-4 max-w-full">
      {/* Province / Territory Select */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          State
        </label>
        <select
          value={province}
          onChange={(e) => {
            setProvince(e.target.value);
            setCity(""); // Reset city when province changes
            if (onChange) {
              onChange("province");
              onChange("city");
            }
          }}
          className="w-full border p-2 rounded-md"
        >
          <option value="">Select State</option>
          {states.map((prov) => (
            <option key={prov.isoCode} value={prov.isoCode}>
              {prov.name} ({prov.isoCode})
            </option>
          ))}
        </select>
      </div>

      {/* City Select */}
      {(!level || level === SiteLevel.ADDRESS || level === SiteLevel.CITY) && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            City
          </label>
          <select
            value={city}
            onChange={(e) => {
              setCity(e.target.value);
              if (onChange) {
                onChange("city");
              }
            }}
            disabled={!province}
            className="w-full border p-2 rounded-md disabled:bg-gray-100"
          >
            <option value="">Select City</option>
            {cities.map((city) => (
              <option key={city.name} value={city.name}>
                {city.name}
              </option>
            ))}
          </select>
        </div>
      )}
      {/* Street Address Input */}
      {(!level || level === SiteLevel.ADDRESS) && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Street Address
          </label>
          <input
            type="text"
            value={address}
            onChange={(e) => {
              setAddress(e.target.value);
              if (onChange) {
                onChange("address");
              }
            }}
            placeholder="e.g. 123 Yonge Street, Apt 4B"
            className="w-full border p-2 rounded-md"
          />
        </div>
      )}
    </div>
  );
};
